var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6335d8e8-851f-415e-b7d6-a2255430eeec",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-bf61c9b0-6485-40fa-95e7-59fdd0f43a38",
    x1: -7763.779,
    y1: 45.472,
    x2: -7755.518,
    y2: 42.465,
    gradientTransform: "translate(-7744.229) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85b1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#7aa8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#699bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#5f93ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5c91ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdd4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5df3d06e-6f3c-4423-8cec-607017136518",
    x1: -7768.718,
    y1: 26.973,
    x2: -7762.958,
    y2: 26.973,
    gradientTransform: "translate(-2606.205 -7280.801) rotate(-109.977) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c63b0f6b-2127-44ee-807d-5faed9bf5efc",
    x1: -7768.619,
    y1: 30.112,
    x2: -7761.144,
    y2: 30.112,
    gradientTransform: "translate(-7744.229) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-148d2643-ee70-4c3a-bed1-70dfbcb06a6f",
    x1: -7597.2,
    y1: 31.021,
    x2: -7585.05,
    y2: 4.964,
    gradientTransform: "translate(-7570.277) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c1338cc4-b808-4288-820b-47ac2049934c",
    x1: -7604.914,
    y1: 29.782,
    x2: -7590.94,
    y2: -0.185,
    gradientTransform: "translate(-7570.277) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-082770a8-a24c-4c84-b2fd-99ed9df60800",
    x1: 9.582,
    y1: 18.177,
    x2: 32.692,
    y2: 18.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afafaf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c1b8d8f4-5959-40af-be19-de268db7d578",
    x1: 11.113,
    y1: 18.177,
    x2: 31.161,
    y2: 18.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0645ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#082fd0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-f5de613e-1f05-4bf3-b442-4e6c7bb1fe98",
    "data-name": "Art"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#f4f4f4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.67,
    cy: 32.277,
    rx: 3.24,
    ry: 4.39,
    transform: "translate(-17.385 39.736) rotate(-70.023)",
    fill: "#bad2fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.039,52.368c-.067-.422-.03-.857,.113-1.26l7.392-20.335c-1.209,4.16,6.527,6.945,8.252,3.006l-7.392,20.335c-.222,.662-.86,1.279-1.59,1.566-2.548,1.024-6.214-.499-6.775-3.312Z",
    fill: "url(#uuid-bf61c9b0-6485-40fa-95e7-59fdd0f43a38)"
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.608,
    cy: 26.973,
    rx: 2.184,
    ry: 2.959,
    transform: "translate(-11.124 38.066) rotate(-70.023)",
    fill: "url(#uuid-5df3d06e-6f3c-4423-8cec-607017136518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.937,31.812c-.005-.033-.009-.066-.012-.099-.001-.014-.004-.028-.005-.042,0-.005,0-.01,0-.015-.001-.018-.002-.036-.002-.055-.001-.027-.002-.054-.002-.081,0-.019,0-.038,.002-.056,0-.016,0-.033,.002-.049,0-.006,.002-.011,.002-.017,.005-.065,.013-.129,.026-.192,0-.004,0-.008,.002-.012,.002-.008,.005-.016,.007-.024,.011-.051,.025-.102,.041-.152,.003-.008,.004-.016,.007-.024,.004-.01,.007-.021,.011-.031l1.815-5.003c-.007,.018-.012,.037-.018,.055-.016,.05-.03,.101-.041,.152-.003,.012-.006,.024-.008,.036-.012,.063-.021,.127-.026,.192-.002,.022-.003,.044-.004,.066,0,.019-.002,.038-.002,.056,0,.027,0,.054,.002,.081,0,.018,.001,.036,.002,.055,.001,.019,.004,.038,.006,.057,.003,.033,.007,.066,.012,.099,.003,.02,.007,.04,.011,.061,.006,.032,.012,.063,.02,.095,.005,.022,.011,.043,.017,.065,.007,.027,.016,.054,.024,.081,.007,.023,.015,.045,.023,.067,.01,.027,.02,.054,.031,.081,.009,.022,.018,.045,.028,.067,.012,.027,.025,.054,.038,.081,.011,.022,.021,.044,.033,.066,.014,.027,.03,.055,.045,.082,.012,.022,.024,.043,.037,.064,.017,.028,.035,.055,.054,.083,.014,.021,.027,.041,.041,.062,.02,.029,.042,.057,.064,.086,.014,.019,.028,.038,.043,.057,.025,.031,.052,.062,.079,.093,.013,.015,.026,.031,.04,.047,.042,.046,.085,.092,.131,.137,.063,.062,.129,.121,.196,.177,.017,.014,.034,.027,.05,.041,.043,.035,.088,.068,.132,.101,.049,.036,.099,.071,.15,.105,.036,.024,.071,.047,.108,.07,.042,.026,.085,.05,.128,.075,.041,.023,.083,.047,.125,.068,.04,.02,.08,.039,.12,.058,.045,.021,.09,.042,.136,.062,.04,.017,.08,.033,.121,.049,.046,.018,.092,.035,.139,.052,.043,.015,.086,.029,.13,.042,.045,.014,.09,.027,.136,.04,.049,.013,.099,.025,.149,.037,.043,.01,.085,.019,.128,.028,.063,.012,.126,.022,.188,.031,.041,.006,.082,.013,.122,.017,.022,.003,.045,.004,.067,.006,.065,.006,.129,.01,.193,.013,.02,0,.04,.002,.06,.003,.081,.002,.162,.001,.242-.002,.015,0,.03-.002,.045-.003,.066-.004,.132-.01,.197-.018,.023-.003,.046-.006,.069-.009,.065-.009,.129-.021,.192-.034,.014-.003,.028-.005,.042-.008,.075-.017,.149-.038,.222-.061,.019-.006,.037-.013,.055-.019,.056-.019,.111-.04,.165-.063,.02-.008,.04-.017,.06-.026,.069-.031,.137-.065,.202-.102,.405-.234,.676-.559,.81-.928l-1.815,5.003c-.134,.369-.405,.694-.81,.928-.065,.038-.133,.071-.202,.102-.02,.009-.04,.017-.06,.026-.054,.023-.109,.044-.165,.063-.018,.006-.037,.013-.055,.019-.073,.023-.147,.044-.222,.061-.014,.003-.028,.005-.043,.008-.063,.013-.127,.025-.192,.034-.023,.003-.046,.006-.069,.009-.065,.008-.13,.014-.196,.018-.015,0-.03,.003-.045,.003-.07,.003-.141,.005-.212,.004-.01,0-.02-.001-.03-.001-.02,0-.04-.002-.06-.003-.064-.003-.129-.007-.193-.013-.022-.002-.045-.004-.067-.006-.014-.002-.028-.002-.042-.004-.027-.003-.053-.009-.08-.013-.063-.009-.126-.019-.188-.031-.016-.003-.033-.005-.049-.008-.026-.005-.052-.013-.078-.019-.05-.011-.099-.023-.149-.037-.019-.005-.039-.009-.058-.014-.026-.008-.052-.017-.077-.025-.043-.013-.087-.027-.13-.042-.019-.007-.039-.012-.058-.019-.027-.01-.054-.022-.081-.033-.04-.016-.081-.032-.121-.049-.017-.007-.035-.013-.052-.021-.028-.013-.056-.027-.084-.041-.04-.019-.081-.038-.12-.058-.015-.008-.031-.014-.046-.022-.027-.014-.052-.031-.079-.046-.043-.024-.086-.049-.129-.075-.015-.009-.03-.017-.045-.026-.022-.014-.042-.03-.063-.044-.051-.034-.101-.068-.15-.105-.017-.012-.035-.023-.052-.036-.028-.021-.054-.044-.081-.065-.017-.014-.034-.027-.05-.041-.061-.051-.12-.104-.177-.159-.006-.006-.013-.012-.019-.018-.046-.045-.089-.091-.131-.137-.014-.015-.026-.031-.04-.047-.027-.031-.054-.062-.079-.093-.015-.019-.029-.038-.043-.057-.022-.029-.043-.057-.064-.086-.014-.02-.027-.041-.041-.062-.018-.028-.037-.055-.054-.083-.013-.021-.025-.043-.037-.064-.016-.027-.031-.054-.045-.082-.011-.022-.022-.044-.033-.066-.013-.027-.026-.054-.038-.081-.01-.022-.019-.045-.028-.067-.011-.027-.021-.054-.031-.081-.008-.023-.015-.045-.023-.067-.009-.027-.017-.054-.024-.081-.003-.011-.007-.023-.01-.034-.003-.01-.004-.021-.007-.031-.008-.032-.014-.063-.02-.095-.004-.02-.008-.041-.011-.061Z",
    fill: "url(#uuid-c63b0f6b-2127-44ee-807d-5faed9bf5efc)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.33,14.94c-.568-2.821-.064-6.675,1.772-8.264,.457-.588,5.968-3.577,6.678-4.047-5.277,3.406-2.43,12.783,.612,17.283,2.588,4.066,8.416,9.765,13.581,7.142l-5.74,3.336c-.479,.276-1.004,.471-1.548,.574-3.684,.592-7.051-1.908-9.478-4.424-2.969-3.219-5.121-7.271-5.877-11.599Z",
    fill: "url(#uuid-148d2643-ee70-4c3a-bed1-70dfbcb06a6f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,24.012c-.479-6.782-4.096-13.284-9.299-17.601-2.82-2.252-6.943-4.251-10.418-2.317L18.693,.758c.678-.393,1.437-.635,2.214-.73,5.62-.449,10.599,4.611,13.449,8.97,3.508,5.179,6.776,16.012,.704,19.927,0,0-5.74,3.336-5.74,3.336,2.259-1.178,3.619-4.651,3.349-8.249Z",
    fill: "url(#uuid-c1338cc4-b808-4288-820b-47ac2049934c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.692,24.849c-.021,7.333-5.212,10.291-11.593,6.607S9.561,18.839,9.582,11.506c.021-7.333,5.21-10.292,11.592-6.608,6.382,3.685,11.539,12.617,11.518,19.95Zm-11.588,4.848c5.528,3.191,10.04,.62,10.058-5.732,.018-6.352-4.465-14.116-9.992-17.307-5.528-3.191-10.038-.619-10.056,5.732-.018,6.352,4.463,14.115,9.991,17.307",
    fill: "url(#uuid-082770a8-a24c-4c84-b2fd-99ed9df60800)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.169,6.657c-5.528-3.191-10.038-.619-10.056,5.732-.018,6.352,4.463,14.115,9.991,17.307,5.528,3.191,10.04,.62,10.058-5.732,.018-6.352-4.465-14.116-9.992-17.307Z",
    fill: "url(#uuid-c1b8d8f4-5959-40af-be19-de268db7d578)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.cd2945c46cde1ccf535f99ad56a972d7.svg";
export { ForwardRef as ReactComponent };